import { not_implemented } from '@shared/asserts/utils_asserts';
import { ELoggerNamespaceShared } from '@shared/logger/e_logger_namespace_shared';
import { DTOPerformaceCapture } from '@shared/utils/performance/dto_performance_capture';
import { timestamp_ms } from '@shared/utils/utils_time';
import { ILogMessageParams } from './i_log_message_params';
import { LogEntryError } from './log_entry_error';

export abstract class ServiceLoggerBase {
  /*
   * STATIC METHODS
   */

  /*
   * INSTANCE FIELDS
   */
  timestamp_previous: number;

  constructor() {
    this.timestamp_previous = timestamp_ms();
  }

  init_colors_map() {
    //  // '#e74c3c', // Red
    //  '#2ecc71', // Green
    //  // '#3498db', // Blue
    //  // '#f1c40f', // Yellow
    //  '#9b59b6', // Purple
    //  // '#34495e', // Dark Blue Gray
    //  // '#e67e22', // Orange
    //  '#ecf0f1', // Light Gray
    //  '#95a5a6', // Gray
    //  // '#ff6b6b', // Coral
    //  '#f8c291', // Peach
    //  // '#6a89cc', // Sky Blue
    //  '#38ada9', // Aqua Green
    //  // '#e58e26', // Bright Orange
    //  '#60a3bc', // Muted Blue
    //  // '#b71540', // Crimson Red
    //  '#78e08f', // Light Green
    //  '#079992', // Deep Teal
    //  // '#dff9fb', // Super Light Blue
  }

  /*
   * COMMON
   */

  fill_performance_capture(params: ILogMessageParams) {
    params.performance_capture ||= DTOPerformaceCapture.CREATE_STUB();
  }

  fill_time_diff(params: ILogMessageParams) {
    let timestamp_now = timestamp_ms();

    let time_diff = timestamp_now - this.timestamp_previous;

    this.timestamp_previous = timestamp_now;

    params.log_time_diff = params.log_time_diff_show ? time_diff : 0;
  }

  fill_bytes(params: ILogMessageParams) {
    if (params.bytes == null) params.bytes = 0;
    if (params.bytes_reference == null) params.bytes_reference = 0;
  }

  fill_log_entry_id(params: ILogMessageParams) {
    if (params.log_entry_id == null) params.log_entry_id = NaN;
  }

  fill_params(params: ILogMessageParams) {
    params.namespace ||= ELoggerNamespaceShared.GLOBAL;

    this.fill_time_diff(params);

    this.fill_performance_capture(params);

    this.fill_bytes(params);

    this.fill_log_entry_id(params);
  }

  /*
   * COLORIZERS
   */

  /*
   * INFO
   */

  log_info(message: string, params: ILogMessageParams) {
    this.fill_params(params);

    this.log_info_internal(message, params);
  }

  protected abstract log_info_internal(message: string, params: ILogMessageParams): void;

  /*
   * WARNING
   */

  log_warning(message: string, params: ILogMessageParams) {
    this.fill_params(params);

    params = { ...params, namespace: ELoggerNamespaceShared.WARNING };

    this.log_warning_internal(message, params);
  }

  protected abstract log_warning_internal(message: string, params: ILogMessageParams): void;

  /*
   * ERROR
   */

  log_error(message: string, params: ILogMessageParams) {
    this.fill_params(params);

    let log_entry_error = new LogEntryError(message, params);

    this.log_error_internal(log_entry_error, params);
  }

  protected log_error_internal(log_entry: LogEntryError, params: ILogMessageParams): void {
    not_implemented();
  }
}
